import React from 'react';
import './Dashboard.css';

const Dashboard = () => {
  const stats = [
    { label: 'Total Users', value: '12,345', change: '+12.5%', positive: true },
    { label: 'Active Orders', value: '1,234', change: '+8.2%', positive: true },
    { label: 'Revenue', value: '$45,678', change: '+23.1%', positive: true },
    { label: 'Products', value: '567', change: '-2.4%', positive: false },
  ];

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Dashboard Overview</h1>
        <p className="dashboard-subtitle">Welcome back! Here's what's happening today.</p>
      </div>

      <div className="stats-grid">
        {stats.map((stat, index) => (
          <div key={index} className="stat-card">
            <div className="stat-header">
              <span className="stat-label">{stat.label}</span>
              <span className={`stat-change ${stat.positive ? 'positive' : 'negative'}`}>
                {stat.change}
              </span>
            </div>
            <div className="stat-value">{stat.value}</div>
            <div className="stat-chart">
              <svg width="100%" height="40" viewBox="0 0 200 40" preserveAspectRatio="none">
                <defs>
                  <linearGradient id={`gradient-${index}`} x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor={stat.positive ? '#6366f1' : '#f87171'} stopOpacity="0.3" />
                    <stop offset="100%" stopColor={stat.positive ? '#6366f1' : '#f87171'} stopOpacity="0" />
                  </linearGradient>
                </defs>
                <path
                  d={`M 0 ${30 - Math.random() * 20} Q 50 ${10 + Math.random() * 15}, 100 ${20 - Math.random() * 10} T 200 ${15 + Math.random() * 10}`}
                  fill={`url(#gradient-${index})`}
                  stroke={stat.positive ? '#6366f1' : '#f87171'}
                  strokeWidth="2"
                />
              </svg>
            </div>
          </div>
        ))}
      </div>

      <div className="charts-grid">
        <div className="chart-card">
          <div className="chart-header">
            <h3>Revenue Overview</h3>
            <select className="chart-filter">
              <option>Last 7 days</option>
              <option>Last 30 days</option>
              <option>Last 90 days</option>
            </select>
          </div>
          <div className="chart-placeholder">
            <svg width="100%" height="200" viewBox="0 0 400 200">
              <defs>
                <linearGradient id="chartGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#6366f1" stopOpacity="0.3" />
                  <stop offset="100%" stopColor="#6366f1" stopOpacity="0" />
                </linearGradient>
              </defs>
              <path
                d="M 0 150 L 50 120 L 100 140 L 150 80 L 200 100 L 250 60 L 300 90 L 350 50 L 400 70"
                fill="url(#chartGradient)"
                stroke="#6366f1"
                strokeWidth="3"
              />
              <path
                d="M 0 150 L 50 120 L 100 140 L 150 80 L 200 100 L 250 60 L 300 90 L 350 50 L 400 70 L 400 200 L 0 200 Z"
                fill="url(#chartGradient)"
              />
            </svg>
          </div>
        </div>

        <div className="chart-card">
          <div className="chart-header">
            <h3>Top Categories</h3>
          </div>
          <div className="category-list">
            {['Electronics', 'Clothing', 'Food & Beverage', 'Home & Garden', 'Sports'].map((category, index) => (
              <div key={index} className="category-item">
                <div className="category-info">
                  <span className="category-name">{category}</span>
                  <span className="category-value">{Math.floor(Math.random() * 500 + 100)}</span>
                </div>
                <div className="category-bar">
                  <div 
                    className="category-bar-fill" 
                    style={{ width: `${Math.random() * 60 + 40}%` }}
                  ></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
